import { Box, Button } from '@mui/material';
import styled from 'styled-components';

export const SearchInputWrapper = styled(Box)(() => ({
  display: 'grid',
  gap: 16,
  gridTemplateColumns: 'repeat(3, 1fr)',
  alignItems: 'center',
  '@media (max-width: 768px)': {
    gridTemplateColumns: '1fr 1fr',
    gap: 16
  },
  '@media (max-width: 666px)': {
    gridTemplateColumns: '1fr',
    gap: 12
  }
}));

export const ButtonWrapper = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'flex-end',
  justifyContent: 'flex-end',
  width: '100%',
  gap: '16px'
}));

export const HeaderWrapper = styled(Box)(() => ({
  maxWidth: '95%',
  marginInline: 'auto',
  marginBlock: 32
}));

export const RoundedButton = styled(Button).attrs({
  variant: 'contained',
  color: 'primary'
})({
  borderRadius: '8px !important',
  width: '170px !important',
  '@media (min-width:600px)': {
    width: 'auto'
  }
});

export const FiltersContainer = styled(Box)`
  display: flex;
  gap: 16px;
  align-items: flex-end;
  width: 100%;
`;

export const FilterColumn = styled(Box)`
  display: flex;
  flex-direction: column;
`;
